export default "__VITE_PUBLIC_ASSET__b8759a27__"